/**
 * @file annotationJsonSave.saga.js
 * @description
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since May 13, 2022 20:41
 */
import { call, put, takeLatest } from 'redux-saga/effects';
import axiosClient from 'src/services/axiosClient.js';

import standardMessages from 'src/services/notifications/standardMessages';
import store from 'src/store';

import {
    enqueueMessage,
} from 'src/store/actions/global.actions';

import { stringExists } from 'src/@common/utilities';

import {
    DOCUMENT_ANNOTATOR_SAVE_ANNOTATION_JSON_REQUEST,
    annotationJsonSaveSuccess,
    annotationJsonSaveFailure,
} from 'src/store/actions/documentAnnotator/documentAnnotatorDb.actions';

import { dataLoadingSet } from 'src/store/actions/global.actions';
import handleSagaErrors from 'src/store/sagas/handleSagaErrors';

function callApi(payload) {
    const url = '/documentAnnotator/annotationJsonSave';

    const baseUrl = import.meta.env.VITE_APP_API_BASE_URL;

    const config = {
        method: 'post',
        baseURL: baseUrl,
        url,
        data: {
            annotationJson: payload,
        },

    };

    return new Promise((resolve, reject) => {
        axiosClient(config)
            .then((response) => {
                resolve(response.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

function* createRequestSaga() {

    //------------- start: redux state --------------------/
    const documentAnnotatorDbState = store.getState().documentAnnotatorDb;

    const {
        annotationJson,
    } = documentAnnotatorDbState;
    //------------- end: redux state --------------------/

    try {
        yield put(dataLoadingSet(true));

        const resp = yield call(callApi, annotationJson);

        if (stringExists(resp.payload.serverMessage)) {
            yield put(enqueueMessage(
                resp.payload.serverMessage,
                standardMessages.generalInfoMessage.options)
            );
        }

        yield put(annotationJsonSaveSuccess(resp.payload));

    } catch (error) {
        yield put(annotationJsonSaveFailure(error));
        handleSagaErrors(error);
    } finally {
        yield put(dataLoadingSet(false));
    }
}

export default function* createRequestMonitor() {
    yield takeLatest(DOCUMENT_ANNOTATOR_SAVE_ANNOTATION_JSON_REQUEST, createRequestSaga);
}
